import React, { useEffect, useState } from "react";
import desIcon from "../../Assets/svg/desclaimer.svg";
import pdf from "../../Assets/svg/pdf-logo.svg";
import tick from "../../Assets/svg/green-bg-tick.svg";

import cross from "../../Assets/svg/cross-grey-icon.svg";
import DocUpload from "../modules/DocUpload";
import Button from "../modules/Button";
import { api } from "../../Services";
import { useDispatch, useSelector } from "react-redux";
// import { Button } from "@mui/material";
import { addTokenInfo, doLogout } from "../LoginPage/redux/actions";
import GradientLoader from "../modules/Loader";
import { setRef } from "@mui/material";
import ModalComponent from "../modules/Modal";
import { GetLogout } from "../modules/Logout";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { resetClear } from "../Connect/redux/actions";

function Reupload(props) {
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState({ showErr: false, errText: "" });
  const [isModal, showModal] = useState({ show: false, msg: "", type: "" });
  const [docReason, setDocReason] = useState([]);
  const [modified, setModified] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [cross, setCross] = useState(true);
  const tokenData = useSelector((state) => state.tokens.tokens);

  const dispatch = useDispatch();
  function validateFileName(fileName) {
    // Split the file name by '.' to get the individual parts
    let name = fileName?.name;
    const parts = name?.split(".");

    // Check if the file name contains more than one part
    if (parts?.length > 2) {
      showModal({
        ...isModal,
        show: true,
        msg: "File with double extensions is not allowed.",
      });
      // alert("File with double extensions is not allowed.");
      fileName = null;
    }
    return fileName;
  }
  const changeDoc = (value) => {
    setModified(true);
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "application/msword",
      ".doc",
      ".docx",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (value) {
      let isFormat = false;
      for (let i in allowedTypes) {
        if (value.type === allowedTypes[i]) {
          isFormat = true;
        }
      }
      if (!isFormat) {
        value = null;
        console.log("doc.type", value.type);
        alert("Only PDF, JPEG, PNG, and Word files are allowed.");
        //   setDoc(null); // Clear the file input
      } else if (value !== null && value.size / 1024 / 1024 > 2) {
        value = null;
        alert(" File size exceeds the maximum upload size limit.");
        // showErr(true)
        // setTimeout(() => showErr(false), 3000);
      }
      value = validateFileName(value);
      setDoc(value);
    }
    setDoc(value);
  };

  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log('logout api', users)
      // if (users.statusCode == 200) {
        dispatch(resetState());
        dispatch(resetIncome());
        dispatch(resetEdu());
        dispatch(resetRegister());
        dispatch(resetApp());
        dispatch(resetQueries());
        dispatch(resetStatus());
        dispatch(clearDisburse());
        dispatch(resetClear());
        dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const setDocs = async (data) => {
    try {
      const result = await api.uploadDocument(
        "application",
        tokenData.applicationData.id,
        tokenData.token,
        data
      );
      if (
        result.statusCode !== 200 &&
        result.data.includes("Session expired")
      ) {
        logoutMsg();
      }
      return result;
    } catch (err) {
      setErr({ showErr: true, errText: err.message });
      if (err?.statusCode !== 200 && err?.data?.includes("Session expired")) {
        logoutMsg();
      }
    }
  };

  const getDocs = async () => {
    try {
      const docs1 = await api.getDocuments(
        "application",
        tokenData.applicationData.id,
        tokenData.token
      );
      if (docs1.statusCode !== 200 && docs1.data.includes("Session expired")) {
        logoutMsg();
      }
      return docs1;
    } catch (err) {
      setErr({ showErr: true, errText: err.message });
      if (err?.statusCode !== 200 && err?.data?.includes("Session expired")) {
        logoutMsg();
      }
    }
  };

  const handleUpload = async (type, e) => {
    e = validateFileName(e);
    let file = e;
    console.log(file);
    if (e) {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", e);
      formData.append("name", e.name);
      formData.append("size", e.size);
      formData.append("documentType", type);
      formData.append("id", doc?.id);
      formData.append("fileType", e.type.split("/")[1]);
      let result = await setDocs(formData);
      if (result.statusCode == 200) {
        setModified(false);
        setCross(false);
      }
      console.log("result", result);
      let docs1 = await getDocs();
      setDoc(docs1.data[type]);
      dispatch(addTokenInfo(["docs", docs1.data]));
      setUploading(false);
    }
  };

  // const renderList = () => {
  //   const result = [];
  //   let tempLine = [];
  //   let reason=doc?.documentUpdateReason?.slice(1,-1) || []
  //   reason=reason?.split(',')
  //   if (doc && doc?.documentUpdateReason) {

  //     console.log('is doc?.documentUpdateReason', doc?.documentUpdateReason)
  //     reason?.forEach((item, index) => {
  //       if (item === "Others") {
  //         // Push the current line to result and start a new line
  //         result.push(
  //           <div className="instructions" key={`line-${index}`}>
  //             {tempLine?.join(", ")}
  //           </div>
  //         );
  //         tempLine = []; // Reset the temporary line
  //       } else {
  //         // Add the item to the current line
  //         tempLine?.push(item);
  //       }
  //     });

  //     // Push the last line if any items are left
  //     if (tempLine?.length > 0) {
  //       result?.push(
  //         <div
  //           className="instructions"
  //           key={`line-${reason.length}`}
  //         >
  //           {tempLine?.join(", ")}
  //         </div>
  //       );
  //     }
  //   }

  //   return result;
  // };

  useEffect(() => {
    console.log("in reupload ueh", props.doc);
    setDoc(props?.doc);
  }, []);
  console.log("in reupload", doc);
  return (
    <div className="item-desc">
      <div className="desc-title md-desc">
        {" "}
        <img src={desIcon} alt="desc icon" />
        Document Incorrect
      </div>
      {/* {doc?.documentUpdateReason?.split("Others")?.map((item, index) => {
        return (
          <div className="instructions" key={index}>
            {index !== 0 ? <>Others, {item}</> : <>{item}</>}
          </div>
        );
      })} */}
      {/* {doc && doc?.documentUpdateReason && renderList()} */}
      <div className="instructions">
        {doc && doc?.documentUpdateReason.slice(1, -1)}
      </div>
      <div className="doc-section">
        {/* {!modified ? ( */}
        <div className="doc-div">
          <div className="doc-div-left">
            <img src={pdf} alt="cross" />
            <div className="doc-div-left-text">
              <div className="text-top">{doc?.name}</div>
              <div className="text-btm text-doc">
                {" "}
                {doc?.size / 1024}
                kb
              </div>
            </div>
          </div>
          {/* {cross && ( */}
          <div className="doc-div-right">
            <input
              type="file"
              onChange={(e) =>
                handleUpload(props?.doc?.documentType, e?.target?.files[0])
              }
            />
            <Button
              // onClickHandler={() => handleUpload(`BirthCertificate`)}
              value={"Reupload"}
              type={"contained"}
              // disabled={uploading}
            />
          </div>
          {/* // )} */}
        </div>
        {/* ) : (
          <>
            <DocUpload
              noTooltip={true}
              placeholder={""}
              onChange={(e) => handleUpload(props.doc.documentType,e)}
              title={""}
              value={doc}
            />
           
          </>
        )} */}
      </div>
      <ModalComponent
        className={"loader-model"}
        show={uploading}
        // handleClose={() => CancelData()}
        // title={ModalData.title}
        // content={ModalData.desc}
      >
        <GradientLoader />
      </ModalComponent>
      {isModal.show && (
        <ModalComponent
          className={"disburse-model"}
          show={isModal.show}
          handleClose={() => showModal({ ...isModal, show: false })}
          // title={ModalData.title}
          // content={ModalData.desc}
          noCross={true}
          // countDown={ModalData.countDown}
        >
          <div className="modal-set">
            <div>
              {isModal.msg ===
                "Your Document has been uploaded successfully!" && (
                <img src={tick} alt="tick" />
              )}
            </div>
            <div className="md-title">
              {/* Document uploaded successfully! */}
              {isModal.msg}
            </div>
            {/* <div className="md-desc">
                You will receive email notifications on your scholarship
                payment(s), once disbursed.
              </div> */}
            <div className="modal-btn-set">
              <Button
                onClickHandler={() => showModal(false)}
                type={"contained "}
                value={"OK"}
              />
            </div>
          </div>

          {/* <div className="modal-btn-set">
              <Button
                onClickHandler={() => CancelData()}
                type={"contained override"}
                value={"No"}
              />
              <Button
                onClickHandler={() => nextPage()}
                type={"contained "}
                value={ModalData.type === "confirm" ? "Yes, Submit" :ModalData.type === "cancel" ?"Yes": "Okay"}
              />
            </div> */}
        </ModalComponent>
      )}
    </div>
  );
}

export default Reupload;
